// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3Mcbz","unreadBadge":"styles_unreadBadge__2WY3v","modalContent":"styles_modalContent__odE4y","modal":"styles_modal__Eo-cv"};